import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import InvoiceFilterBar, { InvoiceFilterKey } from 'components/invoices/InvoiceFilterBar';
import InvoicesTable, { InvoicesTableSearchFilters } from 'components/invoices/InvoicesTable';
import { useSearchParams } from 'react-router-dom';
import { AthleteRetrieve } from 'types';

const FILTERS: InvoiceFilterKey[] = [
  'search',
  'dueDateRange',
  'status',
  'productType',
  'autoPay',
  'paymentMethods',
];

const Invoice = ({
  athlete,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  permission?: boolean;
}): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const invoiceIdFromUrl = searchParams.get('invoiceId');

  const initialSearchFiltersValue: InvoicesTableSearchFilters = {
    athlete: athlete.athleteId,
    search: '',
    dueDateRange: [null, null],
    status: [],
    autoPay: null,
    paymentMethods: [],
  };

  const [searchFilters, setSearchFilters] = useState<InvoicesTableSearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<InvoicesTableSearchFilters>(searchFilters, 250);

  const [orderingValue, setOrderingValue] = useState('dueDate');

  const handleClearInvoiceIdFromUrl = (): void => {
    searchParams.delete('invoiceId');
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <>
      <InvoiceFilterBar
        source='athlete-invoices'
        title='Invoices'
        variant='embedded'
        titleOrder={2}
        filters={FILTERS}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        csvReportType='athlete-invoices-export'
        searchPlaceholder='Search by product name'
      />

      <InvoicesTable
        searchFilters={debouncedSearchFilters}
        removeColumns={['athlete']}
        permission={permission}
        setOrderingValue={setOrderingValue}
        initialInvoiceId={invoiceIdFromUrl || undefined}
        onDrawerClose={handleClearInvoiceIdFromUrl}
      />
    </>
  );
};

export default Invoice;
